/* Built In Imports */

/* External Imports */
import { Box, Heading, Image, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import Slider from 'react-slick';

/* Internal Imports */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';
/* Services */

/**
 * Renders the Card Info 1 Card component
 * @param {Object} sectionContent - Data for section
 * @returns {ReactElement} CardGrid Card component
 */
const CardMsr1ColumnSliderGrouph = ({ sectionContent, lang, region }) => {
  const objArrows = {
    pos: 'absolute',
    top: '40%',
    zIndex: '10',
    cursor: 'pointer',
    bgSize: '10px',
    w: '56px',
    h: '56px',
    boxShadow: '0 0 7px 0 rgb(0 0 0 / 13%)',
    bgPos: 'center',
    bgRepeat: 'no-repeat',
    color: 'transparent',
    bgColor: '#fff',
    borderRadius: '50%',
  };

  const NextArrow = props => {
    const { onClick } = props;
    return (
      <Box
        {...objArrows}
        bgImage={`url(${config.staticPath}/assets/images/right-arrow.svg)`}
        right={{ base: '-10px', md: '-80px' }}
        onClick={onClick}
        display={{ base: 'none', md: 'block' }}
        backgroundColor={'#FFA735'}
        boxShadow={'0px 4px 12.8px 0px #00000026'}
        border={'2.5px solid #0B0E34'}
      ></Box>
    );
  };

  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        {...objArrows}
        bgImage={`url(${config.staticPath}/assets/images/left-arrow.svg)`}
        left={{ base: '-10px', md: '-80px' }}
        onClick={onClick}
        display={{ base: 'none', md: 'block' }}
        backgroundColor={'#FFA735'}
        boxShadow={'0px 4px 12.8px 0px #00000026'}
        border={'2.5px solid #0B0E34'}
      />
    );
  };

  const settings = {
    dots: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 11000,
    lazyLoad: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
    customPaging: function (i) {
      return (
        <Text
          cursor="pointer"
          display={'inline-block'}
          w="16px"
          h="16px"
          m={{ base: '-5px 8px', md: '-10px 8px' }}
          bgColor="#c4c4c4"
          borderRadius="50%"
        ></Text>
      );
    },
  };
  return (
    <Box mx="auto" w="full">
      <Box
        px={{ base: '-20px', sm: '-20px', md: '50px' }}
        mb={{ base: '0', sm: '0', lg: lang == 'ta' ? '50px' : '100px' }}
        mt={lang == 'ta' ? '15px' : '30px'}
        maxW={{ base: '100%', lg: '750px' }}
        w="full"
        mx="auto"
        className="artist-performers"
      >
        <Slider {...settings} className="slideW">
          {sectionContent &&
            sectionContent?.images?.map(cardDetail => {
              return (
                <Box
                  maxW="650px"
                  height={{ base: 'auto', md: '390px' }}
                  w="full"
                  pos="relative"
                  marginBottom={{ base: '0px', sm: '0px', lg: '30px' }}
                >
                  <Box textAlign="center">
                    <Image
                      src={cardDetail?.url}
                      width="650px"
                      height={{ base: '220px', md: '390px' }}
                    />
                  </Box>
                </Box>
              );
            })}
        </Slider>
      </Box>
      <style>
        {`
          .slick-dots li.slick-active p {
            background-color: #f5ac3e;
          }
          @media (min-width:1024px) and (max-width:1140px) {
              .slideW {
                width: 1140px
              }
          }
          @media (max-width:767px) {
            .artist-performers .slick-list{
              margin-bottom: 90px !important;
              margin-left: 16px;
            }
            .artist-performers .slick-dots{
              bottom: -70px;
              margin-bottom: 20px;

            }
            .slideW {
              width: 100%;
            }
            .artist-performers .slick-dots li{
              width: 10px;
              height: 10px;
              margin: 0 0 0 8px;
            }
            .artist-performers .slick-dots li p{
              width: 10px;
              height: 10px;
              margin: 0;
            }
          }
          @media (max-width: 668px) {
            .slideW .slick-list .slick-active {
              width: 273px !important;
              margin:0px;
            }
            .slideW .slick-list .slick-slide {
              width: 273px !imporant;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default CardMsr1ColumnSliderGrouph;
